import React from 'react';
import DropShip from './dropship';
import { IContainerProps } from './dropshipinterface';

const DropshipContainer = (props: IContainerProps) => {

  return (
      <DropShip
          isPromoChanges={props.isPromoChanges}
          getItemSummaryDetailsWithoutLoading={props.getItemSummaryDetailsWithoutLoading}
          itemSummaryDetails={props.itemSummaryDetails}
          cartsDetails={props.cartsDetails}
          setActive={props.setActive}
          shoppingcartOnClick={props.shoppingcartOnClick}
          formWizardRef={props.formWizardRef}
          getAvailabilityDetails={props?.getAvailabilityDetails}
          availabilityDetails={props?.availabilityDetails}
          getIsNextDisableStatus={props?.getIsNextDisableStatus}
          updateStepperDetails={props?.updateStepperDetails}
          phoneCodeOption={props?.phoneCodeOption}
          fulfillmentDetailRes={props?.fulfillmentDetailRes}
          saveFulfillmentType={props?.saveFulfillmentType}
          isNextClick={props?.isNextClick}
          setIsServiceTypeRequired={props?.setIsServiceTypeRequired}
      />
    )
}

export default DropshipContainer